import executeApi from './executeApi';
import { fetchAuthSession } from 'aws-amplify/auth';
import { SystemError } from "../../constants";

/** 'アカウント情報変更 */
const accountChange = async (
  deleteMail: string,
  insertMail: string,
  operationFlag: string
) => {
  // 認証
  const session = await fetchAuthSession();
  const contractInfo = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]");
  const detailsManagementNo = contractInfo.length !== 0 && contractInfo[0].detailsManagementNo;
  const sessionId = session.tokens?.idToken?.payload?.sessionId;
  const jwtToken = session.tokens?.idToken?.toString();
  // EyesFrontAPIのURLを取得
  const baseURL = process.env.REACT_APP_EYES_FRONT_API_ROOT!;
  // アカウント情報変更API PATH
  const path = "/account/change/execution";
  const request = {
    "sessionId": sessionId,
    "detailsManagementNo": detailsManagementNo,
    "deleteMail": deleteMail,
    "insertMail": insertMail,
    "operationFlag": operationFlag
  };

  try {
    const response = await executeApi(baseURL, path, jwtToken, 0, request);
    // レスポンスコード返却
    if (!response || response.data.resCd == "") {
      return SystemError
    } else {
      return response.data.resCd
    }
  } catch (e) {
    return SystemError;
  }
};

export default accountChange;